// frontend/packages/business-console/src/pages/Quotes/demoQuoteDetail.js
//
// Detail-level fixtures for the Quote detail page. Activated via the
// `?demo=1` flag. The list fixtures in `demoData.js` carry summary
// rows; this file extends those with full line items, totals, notes,
// terms, customer snapshot, and timestamps — everything the detail
// page needs to render the WYSIWYG document body.

const ACME = {
  _id: 'demo_customer_acme',
  firstName: 'Casey',
  lastName: 'Donnelly',
  companyName: 'Acme Roofing LLC',
  email: 'casey@acme-roofing.example',
  phone: '(312) 555-0142',
  address: {
    line1: '240 N Industrial Ave',
    city: 'Aurora',
    state: 'IL',
    postalCode: '60506',
  },
};

const SANTOS = {
  _id: 'demo_customer_santos',
  firstName: 'Maria',
  lastName: 'Santos',
  email: 'maria.santos@example.test',
  phone: '(708) 555-0188',
  address: {
    line1: '1132 Oak St',
    city: 'Naperville',
    state: 'IL',
    postalCode: '60540',
  },
};

const HENDERSON = {
  _id: 'demo_customer_henderson',
  firstName: 'Lee',
  lastName: 'Henderson',
  companyName: 'Henderson Group',
  email: 'lee@hendersongroup.example',
  phone: '(630) 555-0177',
  address: {
    line1: '4400 Corporate Way, Suite 200',
    city: 'Lisle',
    state: 'IL',
    postalCode: '60532',
  },
};

const TILBURY = {
  _id: 'demo_customer_tilbury',
  firstName: 'Mark',
  lastName: 'Tilbury',
  companyName: 'Tilbury Construction',
  email: 'mark@tilburyconstruction.example',
  phone: '(847) 555-0193',
  address: {
    line1: '78 Industrial Park Dr',
    city: 'Schaumburg',
    state: 'IL',
    postalCode: '60173',
  },
};

const WAGNER = {
  _id: 'demo_customer_wagner',
  firstName: 'Olivia',
  lastName: 'Wagner',
  companyName: 'Wagner Hospitality',
  email: 'olivia@wagnerhospitality.example',
  phone: '(312) 555-0166',
  address: {
    line1: '555 Lake Shore Blvd',
    city: 'Chicago',
    state: 'IL',
    postalCode: '60611',
  },
};

const DEMO_QUOTES_FULL = {
  demo_quote_91: {
    quote: {
      _id: 'demo_quote_91',
      number: 'Q-0091',
      state: 'accepted',
      customerId: 'demo_customer_acme',
      title: 'Storm damage repair',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Tear-off + haul-away (existing 28-square)',
          quantity: '28',
          unitPrice: 12500,
          taxable: false,
          lineSubtotal: 350000,
          lineTax: 0,
          lineTotal: 350000,
        },
        {
          id: 'li_2',
          position: 1,
          description:
            'New architectural shingle (GAF Timberline HDZ, charcoal)',
          quantity: '28',
          unitPrice: 8500,
          taxable: false,
          lineSubtotal: 238000,
          lineTax: 0,
          lineTotal: 238000,
        },
        {
          id: 'li_3',
          position: 2,
          description:
            'Synthetic underlayment + ice/water shield (eaves + valleys)',
          quantity: '1',
          unitPrice: 42000,
          taxable: false,
          lineSubtotal: 42000,
          lineTax: 0,
          lineTotal: 42000,
        },
        {
          id: 'li_4',
          position: 3,
          description: 'Step + drip flashing replacement',
          quantity: '1',
          unitPrice: 18000,
          taxable: false,
          lineSubtotal: 18000,
          lineTax: 0,
          lineTotal: 18000,
        },
      ],
      subtotal: 648000,
      discountTotal: 0,
      taxTotal: 0,
      total: 648000,
      currency: 'USD',
      validUntil: '2026-06-30T00:00:00Z',
      terms:
        'Net 30 from invoice date. Materials warranty per manufacturer; labor warranty 5 years.',
      notes:
        "Quote based on visual inspection 5/24/2026. Any structural damage discovered during tear-off may require additional scope — we'll call before proceeding.",
      customerNotes: '',
      viewToken: 'demo-acme-q91-fake-view-token-xyz',
      sentAt: '2026-05-24T14:00:00Z',
      viewedAt: '2026-05-25T09:08:00Z',
      acceptedAt: '2026-05-26T13:14:00Z',
      declinedAt: null,
      convertedInvoiceId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/quotes/demo-q91.pdf',
        renderedAt: '2026-05-24T14:00:01Z',
        templateVersion: 'quote-v1',
      },
      createdAt: '2026-05-24T11:30:00Z',
      updatedAt: '2026-05-26T13:14:00Z',
    },
    customer: ACME,
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canDecline: false,
      canVoid: true,
      canConvert: true,
      canResend: false,
      allowedTransitions: ['converted', 'void'],
    },
  },
  demo_quote_92: {
    quote: {
      _id: 'demo_quote_92',
      number: 'Q-0092',
      state: 'draft',
      customerId: 'demo_customer_henderson',
      title: 'Annual maintenance contract',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Quarterly system inspection (4 visits/yr)',
          quantity: '4',
          unitPrice: 65000,
          taxable: false,
          lineSubtotal: 260000,
          lineTax: 0,
          lineTotal: 260000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'Priority service-call response (1-business-day SLA)',
          quantity: '1',
          unitPrice: 120000,
          taxable: false,
          lineSubtotal: 120000,
          lineTax: 0,
          lineTotal: 120000,
        },
        {
          id: 'li_3',
          position: 2,
          description: 'Filter + minor consumables included',
          quantity: '1',
          unitPrice: 160000,
          taxable: false,
          lineSubtotal: 160000,
          lineTax: 0,
          lineTotal: 160000,
        },
      ],
      subtotal: 540000,
      discountTotal: 0,
      taxTotal: 0,
      total: 540000,
      currency: 'USD',
      validUntil: null,
      terms: '',
      notes: 'Still finalizing scope with Lee on the SLA tier.',
      customerNotes: '',
      viewToken: null,
      sentAt: null,
      viewedAt: null,
      acceptedAt: null,
      declinedAt: null,
      convertedInvoiceId: null,
      pdf: null,
      createdAt: '2026-05-25T14:11:00Z',
      updatedAt: '2026-05-25T14:11:00Z',
    },
    customer: HENDERSON,
    availableActions: {
      canEdit: true,
      canDelete: true,
      canSend: true,
      canDecline: false,
      canVoid: true,
      canConvert: false,
      canResend: false,
      allowedTransitions: ['sent', 'void'],
    },
  },
  demo_quote_93: {
    quote: {
      _id: 'demo_quote_93',
      number: 'Q-0093',
      state: 'viewed',
      customerId: 'demo_customer_santos',
      title: 'Gutter cleaning + soffit repair',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Gutter cleaning, full perimeter (single-story)',
          quantity: '1',
          unitPrice: 25000,
          taxable: false,
          lineSubtotal: 25000,
          lineTax: 0,
          lineTotal: 25000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'Soffit panel replacement — 3 panels (north elevation)',
          quantity: '3',
          unitPrice: 14000,
          taxable: false,
          lineSubtotal: 42000,
          lineTax: 0,
          lineTotal: 42000,
        },
      ],
      subtotal: 67000,
      discountTotal: 0,
      taxTotal: 500,
      total: 67500,
      currency: 'USD',
      validUntil: '2026-06-15T00:00:00Z',
      terms: 'Net 15. 1.5%/mo on past-due balances.',
      notes: 'Crew assignment pending — earliest week of 6/2.',
      customerNotes: '',
      viewToken: 'demo-santos-q93-fake-view-token-xyz',
      sentAt: '2026-05-25T16:42:00Z',
      viewedAt: '2026-05-26T10:02:00Z',
      acceptedAt: null,
      declinedAt: null,
      convertedInvoiceId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/quotes/demo-q93.pdf',
        renderedAt: '2026-05-25T16:42:01Z',
        templateVersion: 'quote-v1',
      },
      createdAt: '2026-05-25T16:42:00Z',
      updatedAt: '2026-05-26T10:02:00Z',
    },
    customer: SANTOS,
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canDecline: true,
      canVoid: true,
      canConvert: false,
      canResend: true,
      allowedTransitions: ['accepted', 'declined', 'expired', 'void'],
    },
  },
  demo_quote_94: {
    quote: {
      _id: 'demo_quote_94',
      number: 'Q-0094',
      state: 'sent',
      customerId: 'demo_customer_tilbury',
      title: 'Tear-off + new shingle',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Tear-off + dump (commercial property, 42-square)',
          quantity: '42',
          unitPrice: 14000,
          taxable: false,
          lineSubtotal: 588000,
          lineTax: 0,
          lineTotal: 588000,
        },
      ],
      subtotal: 421000,
      discountTotal: 167000,
      taxTotal: 0,
      total: 421000,
      currency: 'USD',
      validUntil: '2026-07-10T00:00:00Z',
      terms: 'Net 30',
      notes: 'Volume discount applied per contractor agreement.',
      customerNotes: '',
      viewToken: 'demo-tilbury-q94-fake-view-token-xyz',
      sentAt: '2026-05-26T09:18:00Z',
      viewedAt: null,
      acceptedAt: null,
      declinedAt: null,
      convertedInvoiceId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/quotes/demo-q94.pdf',
        renderedAt: '2026-05-26T09:18:01Z',
        templateVersion: 'quote-v1',
      },
      createdAt: '2026-05-26T09:18:00Z',
      updatedAt: '2026-05-26T09:18:00Z',
    },
    customer: TILBURY,
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canDecline: true,
      canVoid: true,
      canConvert: false,
      canResend: true,
      allowedTransitions: ['viewed', 'accepted', 'declined', 'expired', 'void'],
    },
  },
  demo_quote_90: {
    quote: {
      _id: 'demo_quote_90',
      number: 'Q-0090',
      state: 'accepted',
      customerId: 'demo_customer_wagner',
      title: 'New install — 4 units',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Rooftop unit, 5-ton (incl. install)',
          quantity: '4',
          unitPrice: 78000,
          taxable: false,
          lineSubtotal: 312000,
          lineTax: 0,
          lineTotal: 312000,
        },
      ],
      subtotal: 312000,
      discountTotal: 0,
      taxTotal: 0,
      total: 312000,
      currency: 'USD',
      validUntil: '2026-06-30T00:00:00Z',
      terms: 'Net 30; 25% deposit required before fabrication.',
      notes:
        'Targeting install during scheduled property closure (week of 6/15).',
      customerNotes: '',
      viewToken: 'demo-wagner-q90-fake-view-token-xyz',
      sentAt: '2026-05-23T15:10:00Z',
      viewedAt: '2026-05-24T08:30:00Z',
      acceptedAt: '2026-05-25T15:40:00Z',
      declinedAt: null,
      convertedInvoiceId: 'demo_invoice_180',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/quotes/demo-q90.pdf',
        renderedAt: '2026-05-23T15:10:01Z',
        templateVersion: 'quote-v1',
      },
      createdAt: '2026-05-23T15:10:00Z',
      updatedAt: '2026-05-25T15:40:00Z',
    },
    customer: WAGNER,
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canDecline: false,
      canVoid: true,
      canConvert: true,
      canResend: false,
      allowedTransitions: ['converted', 'void'],
    },
  },
};

const DEMO_BUSINESS = {
  name: 'UpRyzze Demo Co.',
  address: '1500 W Madison St, Chicago, IL 60607',
  email: 'hello@upryzze-demo.example',
  phone: '(312) 555-0100',
};

export function getDemoQuoteDetail(id) {
  const found = DEMO_QUOTES_FULL[id];
  if (!found) return null;
  return {
    ...found,
    business: DEMO_BUSINESS,
  };
}

export { DEMO_BUSINESS };
